const pagesIndividualOperationTasksEn = {
  columns: {
    dueDate: 'Due date',
    progress: 'Progress',
    status: 'Status',
    taskName: 'Task',
  },
  empty: 'No tasks',
  pageTitle: 'My Tasks',
  statuses: {
    Abort: 'Aborted',
    Completed: 'Completed',
    InProgress: 'In Progress',
    NotStarted: 'Not Started',
    Skipped: 'Skipped',
    WaitingApproval: 'Waiting Approval',
  },
  tabs: {
    all: 'All',
    beforeStart: 'Not Started',
    completed: 'Completed',
    inProgress: 'In Progress',
    waitingApproval: 'Waiting Approval',
  },
};

export default pagesIndividualOperationTasksEn;
